import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

// 分页查询文档列表
export const getDocumentList = (params) => {
    params = parseParam(params);
    return request({
        url: `${baseUrl}/joins-resource/v1/document/list?` + params,
        method: 'GET'
    });
};

// 根据类型查询文档列表（不分页）
export const getDocumentListByType = (type) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/document/listByType?type=${type}`,
        method: 'GET'
    });
};

// 根据ID查询文档详情
export const getDocumentDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/document/${id}`,
        method: 'GET'
    });
};

// 新增文档
export const addDocument = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/document`,
        method: 'POST',
        data: data
    });
};

// 修改文档
export const updateDocument = (data) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/document`,
        method: 'PUT',
        data: data
    });
};

// 删除文档
export const deleteDocument = (id) => {
    return request({
        url: `${baseUrl}/joins-resource/v1/document/${id}`,
        method: 'DELETE'
    });
};
